// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';

@Pipe({
    name: 'role',
    standalone: false,
})
export class RolePipe implements PipeTransform {
    constructor (private sessionService: SessionService) {}

    transform (roleTypes: string[]): boolean {
        if (!roleTypes || !Array.isArray(roleTypes)) {
            return false;
        }

        const userRoles = this.sessionService.roles || [];

        for (let i = 0; i < roleTypes.length; i++) {
            if (userRoles.indexOf(roleTypes[i]) !== -1) {
                return true;
            }
        }

        return false;
    }
}
